import { useState, useEffect } from "react";
import {
  adminDeleteUser,
  adminDeleteUserCredit,
  adminImpersonateUser,
  adminSetUserPlan,
  getUserAdmin,
} from "../../api";
import {
  Table,
  Title,
  Grid,
  Text,
  Code,
  Button,
  Badge,
  Group,
  Accordion,
  Paper,
  Select,
  Alert,
  Stack,
  Loader,
  ActionIcon,
} from "@mantine/core";
import UserCreditAdjustForm from "./UserCreditAdjustForm";
import { CopyText } from "../../_Common/CopyText";
import LedgerTable from "./LedgerTable";
import { IconTrash } from "@tabler/icons-react";
import { notifications } from "@mantine/notifications";

export default function UserDetails({ params }) {
  const [impersonateData, setImpersonateData] = useState(null);
  const [user, setUser] = useState(null);
  const [plan, setPlan] = useState(null);

  useEffect(() => {
    setPlan(user?.claims?.Plan);
  }, [user]);

  useEffect(() => {
    getUserAdmin(params.id).then((data) => {
      setUser(data);
    });
  }, [params.id]);

  if (!user) return <Loader />;

  return (
    <Grid p="md">
      <Grid.Col span={12}>
        <Title order={1}>{user.loginName}</Title>
        <Group>
          <Badge color={user.userRole == "User" ? "gray" : "grape"} radius="xs">
            {user.userRole}
          </Badge>
          <Badge color="blue" radius="xs">
            {user.claims?.Plan}
          </Badge>
          <Text c="dimmed">{user.created}</Text>

          <CopyText value={user.email} />

          <Text c="dimmed">{user.email}</Text>
        </Group>
      </Grid.Col>

      <Grid.Col span={12}>
        <Paper>
          <Group>
            <Button
              onClick={() =>
                adminImpersonateUser({ userId: user.id }).then((data) => {
                  setImpersonateData(data);
                })
              }
            >
              Impersonate
            </Button>
            <CopyText value={impersonateData?.loginUrl} />
          </Group>
        </Paper>
      </Grid.Col>

      <Grid.Col span={12}>
        <Stack gap="xs">
          <Text fw={600} fz="sm" tt="uppercase">
            Plan
          </Text>
          <Alert title="Plan Override">
            Setting a user&apos;s plan in this way does NOT give them any credits,
            just enables functionality!
          </Alert>
          <Group>
            <Badge color="blue" radius="xs" size="xl">
              {user.claims.Plan}
            </Badge>

            <Select
              data={["Free", "Basic", "Pro", "Premium"]}
              value={plan}
              onChange={setPlan}
            />

            <Button
              onClick={() =>
                adminSetUserPlan({ userId: user.id, planName: plan })
              }
            >
              Save
            </Button>
          </Group>

          <Text mt="sm" fw={600} fz="sm" tt="uppercase">
            Credits
          </Text>
          <Table>
            <Table.Thead>
              <Table.Tr>
                <Table.Th>Type</Table.Th>
                <Table.Th>Valid</Table.Th>
                <Table.Th ta="right">Initial</Table.Th>
                <Table.Th ta="right">Left</Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {user.credits.map((credits, index) => (
                <Table.Tr key={index}>
                  <Table.Td>{credits.type || "Default"}</Table.Td>
                  <Table.Td>{credits.validUntil}</Table.Td>
                  <Table.Td ta="right">{credits.originalAmount}</Table.Td>
                  <Table.Td ta="right">{credits.amount}</Table.Td>
                  <Table.Td>
                    <ActionIcon
                      variant="light"
                      color="red"
                      onClick={() => {
                        adminDeleteUserCredit(credits.id).then(() => {
                          notifications.show({
                            title: "Credit deleted!",
                            color: "green",
                          });
                        });
                      }}
                    >
                      <IconTrash size={14} />
                    </ActionIcon>
                  </Table.Td>
                </Table.Tr>
              ))}
            </Table.Tbody>
          </Table>
          <UserCreditAdjustForm userId={user.id} />
        </Stack>
      </Grid.Col>
      <Grid.Col span={12}>
        <Paper my="xl">
          <Title order={3}>Last Credit Additions</Title>
          <LedgerTable ledger={user.ledgerAdditions} />
        </Paper>

        <Paper my="xl">
          <Title order={3}>Last Transactions</Title>
          <LedgerTable ledger={user.ledger} />
        </Paper>
      </Grid.Col>
      <Grid.Col span={12}>
        <Accordion>
          <Accordion.Item key="json" value="json">
            <Accordion.Control>JSON</Accordion.Control>
            <Accordion.Panel>
              {" "}
              <Code block>{JSON.stringify(user, null, 2)}</Code>
            </Accordion.Panel>
          </Accordion.Item>
        </Accordion>
      </Grid.Col>

      <Grid.Col span={12}>
        <Paper my="xl">
          <Title>Delete User</Title>
          <Group>
            <Button
              color="red"
              onClick={() =>
                adminDeleteUser(user.id).then(() => {
                  notifications.show({
                    title: "User deleted!",
                    color: "green",
                  });
                })
              }
            >
              Delete User
            </Button>
          </Group>
        </Paper>
      </Grid.Col>
    </Grid>
  );
}
